import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config/configuration_keys.json';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const REACT_APP_API_URL = config.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${REACT_APP_API_URL}/subscribe`, { email });
      if (response?.status === 200) {
        setEmail('');
        setErrorMessage('')
        setSuccessMessage(response.data.message)
        setTimeout(() => setSuccessMessage(''), 5000);
      } else {
        setSuccessMessage('')
        setErrorMessage('Something Went Wrong')
        setTimeout(() => setErrorMessage(''), 5000);
      }
    } catch (error) {
      setSuccessMessage('')
      setErrorMessage(error.response.data.message)
      setTimeout(() => setErrorMessage(''), 5000);
    }
  };

  return (
    <footer>
      <div className="container">
        <div className="row footer-menu_row">
          <div className="col-lg-3 col-md-3 col-sm-12">
            <h2>Sitemap</h2>
            <ul>
              <li>
                <Link to="/products" title="Products">Products</Link>
              </li>
              <li>
                <Link to="/investments" title="Investment">Investments</Link>
              </li>
              <li>
                <Link to="/loan" title="Loan Applications">Loan Applications</Link>
              </li>
              <li>
                <Link to="/faq" title="FAQ">FAQ</Link>
              </li>
              <li>
                <Link to="/contact" title="Contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12">
            <h2>Services</h2>
            <ul>
              <li>
                <Link to="/products/salary-advance" title="Salary Advance">Salary Advance</Link>
              </li>
              <li>
                <Link to="/products/small-equipment-leasing" title="Small Equipment Leasing">Small Equipment Leasing</Link>
              </li>
              <li>
                <Link to="/products/sme-lending" title="SME Lending">SME Lending</Link>
              </li>
              <li>
                <Link to="/products/vendor-financing" title="Vendor Financing">Vendor Financing</Link>
              </li>
              <li>
                <Link to="/products/trader-loans" title="Trader Loans">Trader Loans</Link>
              </li>
              <li>
                <Link to="/products/travel-loans" title="Trader Loans">Travel Loans</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <h2>Subscribe to our Newsletter</h2>
            <p>Stay informed with the latest trends and news in home appliances and small business equipment leasing.</p>
            <div className="newsletter">
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  value={email}
                  aria-describedby="emailHelp"
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <div className="input-group-append">
                  <span className="input-group-text">
                    <button onClick={handleSubmit} type="submit">
                      <svg width={23} height={23} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.949253 10.3398L8.21434 13.08L15.0452 7.38003C15.2083 7.24399 15.4471 7.25553 15.5973 7.4057C15.7476 7.55587 15.7591 7.79459 15.623 7.95759L9.9206 14.7855L12.662 22.0475C12.87 22.6251 13.4234 23.0088 14.0384 22.9998C14.656 23.0075 15.2094 22.6212 15.4162 22.0398L22.9173 1.82637C23.0688 1.4131 23.0097 0.952318 22.7606 0.590402C22.5115 0.227171 22.1019 0.00772132 21.6615 0C21.4958 0.00128338 21.3328 0.0308032 21.1787 0.0885587L0.956604 7.58284C0.381366 7.79846 0 8.34778 0 8.96128C0 9.57606 0.381366 10.1254 0.956604 10.3397L0.949253 10.3398Z" fill="white" />
                      </svg>
                    </button>
                  </span>
                </div>
              </div>
              {successMessage && <div className='success'>{successMessage}</div>}
              {errorMessage && <div className="error">{errorMessage}</div>}
            </div>
          </div>
        </div>
      </div>
      {/* copyright section start here */}
      <div className="copy_right">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-5 col-sm-6 col-7">
              <h4>Copyright © 2025. All Rights Reserved.</h4>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-6 col-5">
              <ul>
                <li>
                  <a href="https://www.instagram.com/microleasingltd/" title="instagram" target="_blank" rel="noopener noreferrer">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.66747 10C6.66747 8.15912 8.15945 6.6664 10.0004 6.6664C11.8414 6.6664 13.3341 8.15912 13.3341 10C13.3341 11.8409 11.8414 13.3336 10.0004 13.3336C8.15945 13.3336 6.66747 11.8409 6.66747 10ZM4.86531 10C4.86531 12.836 7.16429 15.1349 10.0004 15.1349C12.8365 15.1349 15.1355 12.836 15.1355 10C15.1355 7.164 12.8365 4.86512 10.0004 4.86512C7.16429 4.86512 4.86531 7.16384 4.86531 10ZM14.1388 4.66152C14.1387 4.89886 14.209 5.13089 14.3408 5.32829C14.4726 5.52568 14.6599 5.67956 14.8792 5.77047C15.0984 5.86138 15.3397 5.88524 15.5725 5.83904C15.8053 5.79283 16.0192 5.67862 16.1871 5.51087C16.355 5.34311 16.4694 5.12934 16.5157 4.89658C16.5621 4.66382 16.5385 4.42253 16.4477 4.20322C16.357 3.98392 16.2033 3.79644 16.006 3.6645C15.8087 3.53257 15.5767 3.4621 15.3393 3.462C15.0212 3.46215 14.7156 3.58856 14.4906 3.81347C14.2656 4.03837 14.1391 4.34339 14.1388 4.66152ZM5.96024 18.1398C4.98524 18.0954 4.4553 17.933 4.10312 17.7958C3.63623 17.6141 3.30309 17.3976 2.95284 17.0478C2.60258 16.6981 2.38578 16.3653 2.20481 15.8984C2.06752 15.5464 1.90512 15.0163 1.86079 14.0414C1.81231 12.9873 1.80263 12.6706 1.80263 10.0002C1.80263 7.32968 1.81311 7.01392 1.86079 5.95896C1.9052 4.984 2.0688 4.45496 2.20481 4.10192C2.38658 3.63504 2.60306 3.30192 2.95284 2.95168C3.30261 2.60144 3.63543 2.38464 4.10312 2.20368C4.45514 2.0664 4.98524 1.904 5.96024 1.85968C7.01436 1.8112 7.33101 1.80152 10.0004 1.80152C12.6698 1.80152 12.9868 1.81184 14.0418 1.85984C15.0168 1.90424 15.5458 2.06784 15.8989 2.20384C16.3658 2.3848 16.6989 2.60208 17.0492 2.95184C17.3994 3.3016 17.6154 3.6352 17.7972 4.10208C17.9345 4.45408 18.0969 4.98416 18.1412 5.95912C18.1897 7.01408 18.1994 7.32984 18.1994 10.0003C18.1994 12.6708 18.1897 12.9866 18.1412 14.0415C18.0968 15.0165 17.9336 15.5464 17.7972 15.8986C17.6154 16.3654 17.3989 16.6986 17.0492 17.048C16.6994 17.3974 16.3658 17.6142 15.8989 17.796C15.5469 17.9333 15.0168 18.0957 14.0418 18.14C12.9876 18.1885 12.671 18.1982 10.0004 18.1982C7.32981 18.1982 7.01404 18.1883 5.96024 18.1398ZM5.87744 0.0605601C4.81283 0.10904 4.08536 0.27784 3.45006 0.52504C2.79251 0.78032 2.23513 1.1228 1.67855 1.67848C1.12196 2.23416 0.780351 2.7916 0.525061 3.44992C0.277851 4.0856 0.109044 4.81264 0.0605625 5.8772C0.0112805 6.94344 0 7.28432 0 10C0 12.7157 0.0112805 13.0566 0.0605625 14.1228C0.109044 15.1874 0.277851 15.9144 0.525061 16.5501C0.780351 17.2076 1.12204 17.7661 1.67855 18.3215C2.23505 18.877 2.79171 19.219 3.45006 19.475C4.08656 19.7222 4.81283 19.891 5.87744 19.9394C6.94428 19.9879 7.28461 20 10.0004 20C12.7162 20 13.0571 19.9887 14.1234 19.9394C15.188 19.891 15.915 19.7222 16.5507 19.475C17.2083 19.219 17.7657 18.8772 18.3223 18.3215C18.8788 17.7658 19.2197 17.2076 19.4757 16.5501C19.7229 15.9144 19.8926 15.1874 19.9402 14.1228C19.9887 13.0558 20 12.7157 20 10C20 7.28432 19.9887 6.94344 19.9402 5.8772C19.8918 4.81256 19.7229 4.0852 19.4757 3.44992C19.2197 2.7924 18.878 2.23504 18.3223 1.67848C17.7666 1.12192 17.2083 0.78032 16.5515 0.52504C15.915 0.27784 15.188 0.10824 14.1242 0.0605601C13.0577 0.0118401 12.717 0 10.0016 0C7.28621 0 6.94428 0.0112801 5.87744 0.0605601Z" fill="white" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/microleasinglimited/" title="facebook" target="_blank" rel="noopener noreferrer">
                    <svg width={10} height={19} viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0.00345471L7.22185 0C4.52773 0 2.78739 1.83436 2.78739 4.67659V6.83136H0V10.7307H2.78739L2.78403 19H6.68403L6.68739 10.7307H9.88571L9.88319 6.83223H6.68739V5.00391C6.68739 4.12473 6.88991 3.67995 8.00336 3.67995L9.9916 3.67909L10 0.00345471Z" fill="white" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/microleasingltd/" title="x" target="_blank" rel="noopener noreferrer">
                    <svg width={19} height={19} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.2909 8.1941L18.1827 0.803711H16.4231L10.499 7.13833L5.86539 0.803711H0L7.21443 10.6576L0 18.3999H1.75962L8.00625 11.7133L12.9039 18.3999H18.7692L11.2909 8.1941ZM2.6101 1.97679H4.95625L16.1298 17.2268H13.7837L2.6101 1.97679Z" fill="white" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="https://ng.linkedin.com/company/microleasingltd/" title="linkedin" target="_blank" rel="noopener noreferrer">
                    <svg width={19} height={19} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M18.3657 18.3999H14.8465V12.2421C14.8465 10.5528 14.1013 9.61038 12.7648 9.61038C11.3105 9.61038 10.4474 10.5924 10.4474 12.2421V18.3999H6.92819V6.96237H10.4474V8.24857C10.4474 8.24857 11.5516 6.3111 14.0397 6.3111C16.5286 6.3111 18.3657 7.82995 18.3657 10.9726V18.3999ZM2.91802 5.13316C1.73116 5.13316 0.769531 4.16366 0.769531 2.968C0.769531 1.77323 1.73116 0.803711 2.91802 0.803711C4.10401 0.803711 5.06563 1.77323 5.06563 2.968C5.06651 4.16366 4.10401 5.13316 2.91802 5.13316ZM0.769531 18.3999H5.16857V6.96237H0.769531V18.3999Z" fill="white" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* copyright section end here */}
    </footer>
  )
}
